import { GameId } from '@common'
import cx from 'classnames'

import styles from './productsContainer.module.scss'
export const ProductsContainer = ({
  children,
  narrow = false,
  game,
  singleProduct = false,
}: {
  children: React.ReactNode
  narrow?: boolean
  game: GameId
  singleProduct?: boolean
}) => {
  return (
    <div
      className={cx(
        styles.productsContainer,
        styles[game],
        { [styles.narrow]: narrow },
        { [styles.singleProduct]: singleProduct },
      )}
    >
      {children}
    </div>
  )
}
